import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { MOBILE_BREAKPOINT } from 'src/config-global';

export const ChatInput = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  marginTop: theme.spacing(3),
  zIndex: 1,
  // resize: 'vertical',
  [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
    padding: theme.spacing(0.75, 2, 1.5),
    borderRadius: theme.spacing(3, 3, 0, 0),
    margin: theme.spacing(0, 2),
    border: 'none',
  },
  '& .MuiInputBase-root': {
    padding: theme.spacing(1, 0.5),
  },
  '& .MuiInputBase-input': {
    padding: 0,
  },
  '.ProseMirror .codeblock': {
    backgroundColor: theme.palette.background.support,
    padding: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),
  },
}));
